import { FC } from 'react';
import { Input } from 'antd';
import BaseItem, { BaseItemProps } from './BaseItem';

interface PasswordItemProps extends BaseItemProps {
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

const PasswordItem: FC<PasswordItemProps> = (props) => {
  const { onChange, ...rest } = props;
  return (
    <BaseItem {...rest}>
      <Input.Password autoComplete='new-password' onChange={onChange} />
    </BaseItem>
  );
};

export default PasswordItem;
